import { Grid, Wrapper, PhotoWrapper, Links, Content } from './Team.styles';
import Image, { StaticImageData } from 'next/image';
import { IconGitHub, IconLinkedin, IconTwitter } from '@components/icons';
import Container from '@components/common/Container';
import Link from '@components/common/Link';

import imageOz from '@public/team/oz.png';
import imageTomer from '@public/team/tomer.png';
import imageRafa from '@public/team/rafa.png';
import imageYotam from '@public/team/yotam.png';
import imageJason from '@public/team/jason.png';
import imageHannah from '@public/team/hannah.png';
import imageAlvin from '@public/team/alvin.png';
import imageRoss from '@public/team/ross.png';
import imageNestor from '@public/team/nestor.jpg';
import imageJulian from '@public/team/julian.jpg';

export default function Team() {
  return (
    <Container>
      <Wrapper>
        <br />
        <h2>Our Team</h2>
        <br />
        <p>We are an experienced team in the DeFi space.</p>
        <br />
        <Grid>
          <Member image={imageOz} first="oz" last="rabinovitch" title="CEO">
            <span>
              <Link href="https://www.linkedin.com/in/oz-rabinovitch/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
            <span>
              <Link href="https://twitter.com/OzDeFiWizard" target="_blank" rel="noreferrer">
                <IconTwitter />
              </Link>
            </span>
          </Member>
          <Member image={imageTomer} first="tomer" last="mayara" title="CTO">
            <span>
              <Link href="https://www.linkedin.com/in/tomermayara/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
            <span>
              <Link href="https://twitter.com/tomermayara" target="_blank" rel="noreferrer">
                <IconTwitter />
              </Link>
            </span>
          </Member>
          <Member image={imageRafa} first="rafa" last="aguiar" title="CMO">
            <span>
              <Link href="https://www.linkedin.com/in/rafael-a-silva/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
            <span>
              <Link href="https://twitter.com/raaguiars" target="_blank" rel="noreferrer">
                <IconTwitter />
              </Link>
            </span>
          </Member>
          <Member image={imageYotam} first="yotam" last="daniel" title="Developer">
            <span>
              <Link href="https://www.linkedin.com/in/yotam-daniel-a0951162/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
          </Member>
          <Member image={imageJason} first="jason" last="stockman" title="Developer">
            <span>
              <Link href="https://www.linkedin.com/in/jasonstockman/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
            <span>
              <Link href="https://github.com/jasonstockman" target="_blank" rel="noreferrer">
                <IconGitHub />
              </Link>
            </span>
          </Member>
          <Member image={imageHannah} first="hannah" last="leitch" title="Lead Product Designer">
            <span>
              <Link href="https://www.linkedin.com/in/hannah-leitch-07771368/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
          </Member>
          <Member image={imageAlvin} first="alvin" last="thomas" title="Community Manager">
            <span>
              <Link href="https://www.linkedin.com/in/vinalvinthomas/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
          </Member>
          <Member image={imageRoss} first="ross" last="O'Donovan" title="Senior Product Manager">
            <span>
              <Link href="https://www.linkedin.com/in/ross-o-3670ab169/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
          </Member>
          <Member image={imageNestor} first="nestor" last="olivares" title="Software Engineer">
            <span>
              <Link href="https://www.linkedin.com/in/nestorolivaresh/" target="_blank" rel="noreferrer">
                <IconLinkedin />
              </Link>
            </span>
          </Member>
          <Member image={imageJulian} first="julian" last="castrence" title="Developer">
            <span>
              <Link href="https://twitter.com/jrcarchimedesfi" target="_blank" rel="noreferrer">
                <IconTwitter />
              </Link>
            </span>
          </Member>
        </Grid>
      </Wrapper>
    </Container>
  );
}

interface MemberProps {
  children?: React.ReactNode;
  image: StaticImageData;
  first: string;
  last: string;
  title: string;
}

function Member({ children, image, first, last, title }: MemberProps) {
  return (
    <div>
      <PhotoWrapper>
        {children !== undefined && <Links>{children}</Links>}
        <Image src={image} placeholder="blur" alt={`${first} ${last}`} />
      </PhotoWrapper>
      <Content>
        <h4>{first}</h4>
        <h4>{last}</h4>
        <span>{title}</span>
      </Content>
    </div>
  );
}
